// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"37435b5d","879":"d7939640"}[chunkId] + ".chunk.js";
};